module.exports = "<app-content></app-content>\r\n\r\n"